<template>
  <a-modal
    title="填报详细报价"
    width="90%"
    :dialog-style="{ top: '10px' }"
    :visible="visible"
    @cancel="$emit('cancel')"
    :maskClosable="false"
    :destroyOnClose="true"
    :confirmLoading="modalLoading"
  >
    <div>
      <a-table
        style="width: 100%"
        class="table"
        bordered
        :dataSource="addData"
        :rowKey="(record) => record.id"
        :pagination="false"
      >
        <a-table-column key="indexNum" width="5%" title="序号" align="center">
          <template slot-scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column
          key="subjectName"
          width="12%"
          :title="
            tenderType == '1' ? '货物名称' : tenderType == '2' ? '工程子项' : '服务子项'
          "
          data-index="subjectName"
        >
          <template slot-scope="text, record">
            {{ record.subjectName }}
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType === '1'"
          key="specifications"
          width="15%"
          data-index="specifications"
        >
          <span slot="title">
            <span style="color: red">*</span>&nbsp;品牌及规格型号
          </span>
          <template slot-scope="text, record">
            <a-textarea
              key="specifications"
              :value="record.specifications"
              style="margin: -5px 0; width: 100%"
              placeholder="品牌及规格型号"
              :auto-size="{ minRows: 2 }"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'specifications')"
            />
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType === '1'"
          key="jscs"
          width="20%"
          title="主要参数"
          data-index="jscs"
        >
          <template slot-scope="text, record">
            <a-textarea
              key="jscs"
              :value="record.jscs"
              style="margin: -5px 0; width: 100%"
              placeholder="主要参数"
              :auto-size="{ minRows: 2 }"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'jscs')"
            />
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType !== '1'"
          key="serviceScope"
          width="25%"
          :title="tenderType === '2' ? '施工范围' : '服务内容'"
          data-index="serviceScope"
        >
          <template slot-scope="text, record">
            <a-input
              key="serviceScope"
              :value="record.serviceScope"
              style="margin: -5px 0"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'serviceScope')"
            />
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType !== '1'"
          key="servicePeriod"
          width="8%"
          align="center"
          :title="tenderType === '2' ? '施工期限' : '服务期限'"
          data-index="servicePeriod"
        >
          <template slot-scope="text, record">
            <a-input
              key="servicePeriod"
              :value="record.servicePeriod"
              style="margin: -5px 0"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'servicePeriod')"
            />
          </template>
        </a-table-column>
        <a-table-column key="ask" width="15%" title="其他说明" data-index="ask">
          <template slot-scope="text, record">
            <a-textarea
              key="ask"
              :value="record.ask"
              style="margin: -5px 0; width: 100%"
              placeholder="其他说明"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'ask')"
            />
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType === '1'"
          key="quantity"
          width="5%"
          title="数量"
          align="center"
          data-index="quantity"
        >
          <template slot-scope="text, record">
            {{ record.quantity }}
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType === '1'"
          key="unit"
          width="5%"
          title="单位"
          data-index="unit"
          align="center"
        >
          <template slot-scope="text, record">
            {{ record.unit }}
          </template>
        </a-table-column>
        <a-table-column
          v-if="tenderType === '1'"
          key="unitPrice"
          width="10%"
          :title="'单价（' + offerTypeText + '）'"
          data-index="unitPrice"
        >
          <span slot-scope="text, record" key="unitPrice">
            <a-input-number
              v-if="offerType == '1'"
              :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
              :value="record.unitPrice"
              style="margin: -5px 0; width: 100%"
              :min="0"
              @change="(value) => onEditPackItemUnitPrice(value, record.id, 'unitPrice')"
            />
            <a-input-number
              v-else
              :value="record.unitPrice"
              style="margin: -5px 0; width: 100%"
              :min="0"
              :max="100"
              @change="(value) => onEditPackItemUnitPrice(value, record.id, 'unitPrice')"
            />
          </span>
        </a-table-column>
        <a-table-column
          key="totalPrice"
          width="15%"
          :title="'总价（' + offerTypeText + '）'"
          data-index="totalPrice"
        >
          <span slot-scope="text, record" key="totalPrice">
            <span v-if="tenderType != '1'">
              <a-input-number
                v-if="offerType == '1'"
                :formatter="(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                :value="record.totalPrice"
                style="margin: -5px 0; width: 100%; color: red"
                :min="0"
                @change="
                  (value) => onEditPackItemTotalPrice(value, record.id, 'totalPrice')
                "
              />
              <a-input-number
                v-else
                :value="record.totalPrice"
                style="margin: -5px 0; width: 100%; color: red"
                :min="0"
                :max="100"
                @change="
                  (value) => onEditPackItemTotalPrice(value, record.id, 'totalPrice')
                "
              />
            </span>
            <div v-else style="color: red">
              {{ record.totalPrice | NumberFormat }}
            </div>
            <!-- <div v-show="false">
              {{ tenderType == "1" ? total_price(record.id) : "" }}
            </div> -->
          </span>
        </a-table-column>
        <a-table-column
          v-if="false"
          key="isimport"
          width="10%"
          title="是否进口"
          data-index="isimport"
        >
          <template slot-scope="text, record">
            <a-input
              key="isimport"
              :value="record.isimport"
              style="margin: -5px 0; width: 100%"
              placeholder="是否进口"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'isimport')"
            />
          </template>
        </a-table-column>
        <a-table-column
          v-if="false"
          key="jhq"
          width="10%"
          title="交货期"
          data-index="jhq"
        >
          <template slot-scope="text, record">
            <a-input
              key="jhq"
              :value="record.jhq"
              style="margin: -5px 0; width: 100%"
              placeholder="交货期"
              @change="(e) => onEditPackItem(e.target.value, record.id, 'jhq')"
            />
          </template>
        </a-table-column>
      </a-table>
      <table class="table_two">
        <tr>
          <td :class="tenderType === '1' ? 'w-1' : 'w-2'">
            <!-- <div v-show="false">{{ total }}</div> -->
            <div class="hj">合计</div>
          </td>
          <td style="font-size: 16px; font-weight: bold; color: red">
            {{ zTotal | NumberFormat }}
          </td>
        </tr>
      </table>
      <table class="table_two">
        <tr>
          <td>备注</td>
          <td :class="tenderType === '1' ? 'w-3' : 'w-4'">
            <a-textarea v-model="Bz" auto-size placeholder="备注" />
          </td>
        </tr>
      </table>
    </div>
    <template slot="footer">
      <a-button key="submit" type="primary" @click="onSubmit"> 保存 </a-button>
    </template>
  </a-modal>
</template>

<script>
import qs from "qs";
export default {
  components: {},
  created() {},
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    stopDate: {
      default: 0,
    },
    serveDate: {
      default: 0,
    },
    bz: {
      type: String,
      default: "",
    },
    offerType: {
      // 报价类型 1为金额 2为折扣率 3为下浮率
      type: String,
      default: "1",
    },
    offerTypeText: {
      type: String,
      default: "元",
    },
  },
  data() {
    return {
      form: this.$form.createForm(this),
      packs: "",
      modalLoading: false,
      tenderType: "",
      bzid: "",
      Bz: "",
      zTotal: 0,
      addData: [],
      formItemLayout: {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 8 },
          md: { span: 12 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
          md: { span: 12 },
        },
      },
      priceStart: 0,
      jingjiaType: "1",
    };
  },
  mounted() {
    this.Bz = this.bz;
  },
  computed: {
    total_price() {
      return function (id) {
        const target = this.addData.filter((item) => id === item.id)[0];
        let totalPrice = target.unitPrice * target.quantity;
        this.addData.filter((item) => id === item.id)[0].totalPrice = totalPrice;
        return totalPrice;
      };
    },
    total() {
      let total = 0;
      if (this.addData.length == 0) {
        return total;
      } else {
        this.addData.forEach((item) => {
          total += item.totalPrice;
        });
        this.zTotal = total;
        return total;
      }
    },
  },
  methods: {
    onSubmit() {
      const that = this;
      var date = new Date(that.stopDate).getTime() - new Date(that.serveDate).getTime();
      if (date < 0) {
        that.$message.info("竞价已结束");
      } else {
        let isSubmit = true;
        let error = "";
        this.modalLoading = true;
        let index = 0;
        this.addData.forEach((item) => {
          if (this.tenderType == '1' && item.specifications == "") {
            error = "品牌及规格型号不能为空";
            isSubmit = false;
            return false;
          }
          if (this.tenderType == "1" && (item.unitPrice == 0 || item.unitPrice == null)) {
            index++;
            return false;
          }
        });

        if (isSubmit) {
          var priceNumber = parseInt(this.zTotal);
          var startPrice = parseInt(this.priceStart);
          if (this.jingjiaType == "2" && priceNumber - startPrice > 0) {
            this.sysError("您的总报价高于最高限价，请检查修改！");
          } else if (this.jingjiaType == "1" && priceNumber - startPrice < 0) {
            this.sysError("您的总报价低于最低限价，请检查修改！");
          } else {
            if (index != 0) {
              that.$message.info(`你有${index}项的报价金额为0`, 4);
            }
            this.submitData();
          }
        } else {
          that.$message.error(error);
        }
      }
    },
    submitData() {
      const that = this;
      let url = "";
      if (that.tenderType == "1") {
        url = "/api/1/bidPacksGoods/addBidPacksGoods.json?";
      } else if (that.tenderType == "2") {
        url = "/api/1/bidPacksEngineer/addBidPacksEngineer.json?";
      } else {
        url = "/api/1/bidPacksService/addBidPacksService.json?";
      }
      this.$http.post(url, this.addData).then(function (response) {
        if (response.code !== 200) {
          that.$message.error("保存失败");
          that.modalLoading = false;
          return;
        }
        that.$message.success("保存成功", 1);
        that.modalLoading = false;
        that.addData = [];
        that.$emit("cancel", that.zTotal, that.Bz);
      });
    },
    initData(packsId, priceStart, jingjiaType) {
      let that = this;
      this.bzid = packsId;
      this.priceStart = priceStart;
      this.jingjiaType = jingjiaType;
      this.$http
        .get("/api/v1/supplier/subject/get_subject_detail.json?packsId=" + packsId)
        .then(function (res) {
          that.tenderType = res.tenderType;
          if (res.result != undefined) {
            that.addData = res.result;
            if (res.list) {
              that.addData.forEach((item) => {
                item["unitPrice"] = 0;
                item["totalPrice"] = 0;
                item["ask"] = "";
                item["specifications"] = "";
              });
            } else {
              let total = 0;
              that.addData.forEach((item) => {
                total += item.totalPrice;
              });
              that.zTotal = total;
            }
          }
        });
    },
    onEditPackItemUnitPrice(value, id, column) {
      const newData = [...this.addData];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        target.totalPrice = value * parseInt(target.quantity);
        this.addData = newData;
      }
      let total =0;
      newData.forEach((item) => {
        total += item.totalPrice;
      });
      this.zTotal = total;
    },
    onEditPackItemTotalPrice(value, id, column) {
      const newData = [...this.addData];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.addData = newData;
      }
      let total =0;
      newData.forEach((item) => {
        total += item.totalPrice;
      });
      this.zTotal = total;
    },
    onEditPackItem(value, id, column) {
      const newData = [...this.addData];
      const target = newData.filter((item) => id === item.id)[0];
      if (target) {
        target[column] = value;
        this.addData = newData;
      }
    },
    sysError(content) {
      let secondsToGo = 3;
      const modal = this.$error({
        title: "温馨提示",
        content: content,
      });
      const interval = setInterval(() => {
        secondsToGo -= 1;
        modal.update({
          content: content,
        });
      }, 1000);
      setTimeout(() => {
        clearInterval(interval);
        modal.destroy();
      }, secondsToGo * 1000);
    },
  },
};
</script>
<style scoped>
.table_two {
  width: 100%;
  border-left: 1px solid #e8e8e8;
}
.table_two td {
  padding: 10px 16px !important;
  border-bottom: 1px solid #e8e8e8;
  border-right: 1px solid #e8e8e8;
}
.w-1 {
  width: 87%;
}
.w-2 {
  width: 81.3%;
}
.w-3 {
  width: 94%;
}
.w-4 {
  width: 93.8%;
}
.hj {
  display: flex;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: bold;
}
/deep/ .table .ant-table-tbody > tr > td,
/deep/ .table .ant-table-thead > tr > th {
  padding: 10px 16px !important;
}
.display {
  display: flex;
  align-items: center;
}
</style>
